
import { i18nText } from '@/locales';
import { IProductsCategoryTitem, IProductsCategoryTypes } from '@/entity/warehouse/Products/Category/Category.types';

export class CategorySelectForm {
    public id?: number | null;
    public parent_id? : number | null;
    constructor() {
        this.id = null;
        this.parent_id = null
    }
}
export class CategoryFormData {
    public id?: number | null;
    public name: string;
    public parent_id: number | null;
    public salon_id?: number | null;
    public archived: boolean;
    public article: string;
    public comment: string;
    public children?: IProductsCategoryTitem;

    setFormData(category: IProductsCategoryTypes): void {
        this.id = category.id;
        this.name = category.name;
        this.parent_id = category.parent_id;
        this.salon_id = category.salon_id;
        this.archived = category.archived;
        this.article = category.article;
        this.comment = category.comment;
        this.children = category.children;
    }
    constructor() {
        this.name = '';
        this.parent_id = null;
        this.archived = false;
        this.article = '';
        this.comment = '';
    }
}
export const CategorySelectRules = {
    id: [{ required: true, message: i18nText("Пожалуйста укажите категорию"), trigger: 'change' }],
};
export const CategoryFormRules = {
    name: [
        { required: true, message: i18nText("Пожалуйста укажите наименование"), trigger: 'change' },
        { min: 2, message: i18nText("Минимальная длина 2 символа"), trigger: 'blur' },
    ],
    parent_id: [{ required: false, message: i18nText("Пожалуйста укажите категорию"), trigger: 'change' }],
    article: [
        { required: false, message: i18nText("Пожалуйста укажите наименование"), trigger: 'change' },
        { min: 2, message: i18nText("Минимальная длина 2 символа"), trigger: 'blur' },
    ],
};
